import axios from "axios";
import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { useRouter } from "vue-router";
import { useModals } from "@/utils/useModals";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useSettingsStore } from "@/stores/storeSettings";
import { useDishesStore } from "@/stores/storeDishes";
import { sendMetrik } from "@/utils/metrika";
import { API_URL } from "@/utils/constans";

export const useRequestsStore = defineStore("request", () => {
	const router = useRouter();
	const storeField = useFieldsStore();
	const storeDishes = useDishesStore();
	const storeSettings = useSettingsStore();
	const { responseOk, closeModal, openModal } = useModals();

	const token = ref(localStorage.getItem("token"));
	const setToken = (newToken) => {
		token.value = newToken;
		localStorage.setItem("token", newToken);
	};

	const removeToken = () => {
		token.value = null;
		localStorage.removeItem("token");
	};

	const loaderBtn = ref(false);
	const userData = ref({});
	const userDataOfSurvey = ref({});
	const userReceiptsData = ref({});
	const userReceiptReults = ref([]);
	const userPrizesData = ref({});
	const listUserPrizes = ref([]);
	const responseError = ref("");
	const isAuthenticated = computed(() => !!token.value);

	axios.interceptors.response.use(
		(response) => response,
		(error) => {
			if (error.response && error.response.status === 401) {
				removeToken();
				delete axios.defaults.headers.common["Authorization"];
			}
			return Promise.reject(error);
		},
	);

	const setAuthHeader = () => {
		// сначала проверяем локалку
		let currentToken = localStorage.getItem("token");

		// если в localStorage ничего нет, пробуем из URL
		if (!currentToken) {
			const urlParams = new URLSearchParams(window.location.search);
			currentToken = urlParams.get("token");
		}

		token.value = currentToken;

		if (token.value) {
			axios.defaults.headers.common["Authorization"] = `Bearer ${token.value}`;
		} else {
			delete axios.defaults.headers.common["Authorization"];
		}
	};

	const registration = async () => {
		loaderBtn.value = true;
		const registrationParams = localStorage.getItem("registration_params") || "";
		const parameters = {
			first_name: storeField.fields.firstName.title,
			phone_number: storeField.fields.phone.title,
			email: storeField.fields.email.title,
			registration_params: registrationParams,
			is_policy: storeField.fields.agreement.title,
			is_rules: storeField.fields.rules.title,
			password: storeField.fields.passwordRepeat.title,
		};

		try {
			const res = await axios.post(`${API_URL}/api/users/registration`, parameters);
			openModal("registrationEnd");
			storeField.updateRegestrationBtn();
			sendMetrik('reachGoal', 'SignUp_SentForm_Success')
		} catch (error) {
			console.error("Error sendRegistration", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			loaderBtn.value = false;
		}
	};

	const registrationAccept = async (token, uuid) => {
		try {
			const res = await axios.patch(`${API_URL}/api/users/registration/accept?token=${token}&uuid=${uuid}`);
			setToken(res.data.access);
			router.push({ name: "profile" });
			await userInfo();
			sendMetrik('reachGoal', 'SignIn_SentForm_Success')
		} catch (error) {
			console.error("Error registrationAccept", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
		}
	};

	const repeatAccept = async () => {
		try {
			setAuthHeader();
			const res = await axios.get(`${API_URL}/api/users/repeat-accept`);	
			openModal("registrationRepeatEnd");		
		} catch (error) {
			console.error("Error repeatAccept", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
		}
	};

	const survey = async () => {
		// if(storeDishes.listDishes.length < 3) {
		// 	responseError.value = 'Добавьте минимум 3 блюда';
		// } else {

			loaderBtn.value = true;	
	
			const formData = new FormData();
	
			if (storeDishes.listDishes.length) {
				storeDishes.listDishes.forEach((dish, index) => {
					formData.append(`dishes[${index}][description]`, dish.description);
					formData.append(`dishes[${index}][photo]`, dish.picture);
				});
			}
	
			
			formData.append("city", storeField.fields.city.title);
			formData.append("restaurant", storeField.fields.restaurant.title);
			formData.append("restaurant_address", storeField.fields.restaurant_address.title);
			formData.append("about_myself", storeField.fields.about_myself.title);
			formData.append("reason", storeField.fields.reason.title);
			formData.append("photo", storeField.fields.photoUser);
	
			try {
				const { data } = await axios.post(`${API_URL}/api/dish/survey`, formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				});
				userDataOfSurvey.value = data;
				await userInfo();
				openModal("surveyEnd");
				sendMetrik('reachGoal', 'Order_ok')
				responseError.value = ''
			} catch (error) {
				console.error("Error survey", error);
				responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
			} finally {
				loaderBtn.value = false;
			}
		// }
	};

	const extraSurvey = async () => {
		loaderBtn.value = true;	
	
		const formData = new FormData();

		if (userData.value?.survey.dishes.length) {
			userData.value?.survey.dishes.forEach((dish, index) => {
				formData.append(`dishes[${index}][id]`, dish.id);
				formData.append(`dishes[${index}][photo_interior]`, dish.photo_interior); 
			});
		}

		
		formData.append("photo_menu", storeField.fields.photoMenu);

		try {
			const { data } = await axios.patch(`${API_URL}/api/dish/survey/extra`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});
			userDataOfSurvey.value = data;
			await userInfo();
			openModal("surveyEnd");
		} catch (error) {
			console.error("Error extraSurvey", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			loaderBtn.value = false;
		}
	};

	const authorization = async () => {
		loaderBtn.value = true;
		const parameters = {
			email: storeField.fields.email.title,
			password: storeField.fields.password.title,
		};
		try {
			const res = await axios.post(`${API_URL}/api/users/authorization`, parameters);
			setToken(res.data.access);
			setAuthHeader();
			await userInfo();
			closeModal();
			sendMetrik('reachGoal', 'SignIn_SentForm_Success')
		} catch (error) {
			console.log("error sendAuthorization:", error);
			if (error.response.status == 400) {
				responseError.value = "Ошибка, обратитесь к разработчикам приложения.";
			} else {
				responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
			}
		} finally {
			loaderBtn.value = false;
			storeField.updateFiles();
		}
	};

	const userInfo = async () => {
		try {
			setAuthHeader();
			const { data } = await axios.get(`${API_URL}/api/users/me`);
			userData.value = data;
		} catch (error) {
			if (error.response && error.response.status === 401) {
				console.warn("Пользователь не авторизован");
				userData.value = null;
			} else {
				console.error("Error getUserInfo", error);
				throw error;
			}
		}
	};

	const recoveryPassword = async () => {
		loaderBtn.value = true;
		const parameters = {
			email: storeField.fields.email.title,
		};
		try {
			const res = await axios.post(`${API_URL}/api/users/recovery-password`, parameters);
			openModal("sentNewPassword");
		} catch (error) {
			console.log("error sendRecoveryPassword:", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных.";
		} finally {
			loaderBtn.value = false;
		}
	};

	const changeUserPassword = async () => {
		loaderBtn.value = true;
		const new_password = { new_password: storeField.fields.password.title };
		try {
			setAuthHeader();
			await axios.patch(`${API_URL}/api/users/change-password`, new_password);
			openModal("sentChangeNewPassword");
			setTimeout(() => {
				closeModal("sentChangeNewPassword");
			}, 2000);
			console.error("Error changePassword", error);
			if (error.response.status == 400) {
				responseError.value = "Ошибка, обратитесь к разработчикам приложения";
			} else {
				responseError.value = error.response?.data?.detail || "Ошибка при отправке данных";
			}
		} finally {
			loaderBtn.value = false;
		}
	};

	const newUserPassword = async (token, uuid) => {
		loaderBtn.value = true;
		const new_password = { password: storeField.fields.password.title };
		try {
			await axios.patch(`${API_URL}/api/users/password?token=${token}&uuid=${uuid}`, new_password);
			openModal("authorization");
			storeField.updatePasswords();
		} catch (error) {
			console.error("Error newUserPassword", error);
			responseError.value = error.response?.data?.detail || "Ошибка при отправке данных";
		} finally {
			loaderBtn.value = false;
		}
	};

	const userPrizes = async (offset, limit) => {
		try {
			setAuthHeader();
			const res = await axios.get(`${API_URL}/api/quiz/user/prizes?offset=${offset}&limit=${limit}`);
			userPrizesData.value = res.data;
			if (offset === 0) {
				listUserPrizes.value = res.data.results;
			} else {
				listUserPrizes.value.push(...res.data.results);
			}
		} catch (error) {
			console.error("Error fetching prizes:", error);
		}
	};

	const finalists = async () => {
		try {
			const { data } = await axios.get(`${API_URL}/api/users/finalists`);
			return data
		} catch (error) {
			console.error("Error fianlists:", error);
		}
	};

	const winner = async () => {
		try {
			const { data } = await axios.get(`${API_URL}/api/users/winner`);
			return data
		} catch (error) {
			console.error("Error fianlists:", error);
		}
	};

	

	const feedback = async () => {
		loaderBtn.value = true;

		const parameters = {
			topic: storeField.fields.select.id,
			name: storeField.fields.firstName.title || userData.value.first_name,
			email: storeField.fields.email.title || userData.value.email,
			files: storeField.fields.filesForPost,
			text: storeField.fields.message.title,
		};

		const formData = new FormData();

		if (parameters.files && parameters.files.length > 0) {
			for (const file of parameters.files) {
				formData.append("files", file);
			}
		}

		formData.append("topic", parameters.topic);
		formData.append("name", parameters.name);
		formData.append("email", parameters.email);
		formData.append("text", parameters.text);

		try {
			const res = await axios.post(`${API_URL}/api/feedback/send`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			});

			openModal("statusOk");
			storeField.fields.files = [];
			storeField.fields.filesForPost = [];
			responseError.value = "";
			storeField.updateRegestrationBtn();
			if (!isAuthenticated.value) {
				userData.value.first_name = "";
				userData.value.email = "";
			}
			// sendMetrik('reachGoal', 'Feedback_SentForm_Success')
		} catch (error) {
			responseError.value = "Ошибка при отправке данных.";
			console.error("Error sendFeedback", error);
		} finally {
			loaderBtn.value = false;
			console.log("storeField.fields.filesForPost:", storeField.fields.filesForPost);
		}
	};

	const topics = async () => {
		try {
			const res = await axios.get(`${API_URL}/api/feedback/topics?limit=1000`);
			return res.data.results;
		} catch (error) {
			console.error("Error sendFeedback", error);
		}
	};

	const logout = () => {
		removeToken();
		userData.value = {};
		userReceiptsData.value = {};
		userReceiptReults.value = [];
		listUserPrizes.value = [];
		storeField.updateFiles();
		router.push({ name: "home" });
		localStorage.removeItem("application");
	};

	return {
		setAuthHeader,
		registration,
		authorization,
		recoveryPassword,
		logout,
		userInfo,
		userPrizes,
		changeUserPassword,
		topics,
		feedback,
		registrationAccept,
		repeatAccept,
		newUserPassword,
		survey,
		extraSurvey,
		finalists,
		winner,

		isAuthenticated,
		loaderBtn,
		userData,
		userDataOfSurvey,
		userReceiptsData,
		userReceiptReults,
		listUserPrizes,
		userPrizesData,
		responseError,
	};
});
